var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isShownOnItemPageCount
      ? _c(
          "div",
          { staticClass: "pt-2" },
          [
            _vm.propertyGroup.group
              ? _c(
                  "div",
                  { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
                  [
                    _c("div", { staticClass: "h4" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.propertyGroup.group.names.name) +
                          ":\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-muted text-wrap" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.propertyGroup.group.names.description) +
                          "\n            "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.propertyGroup.properties, function(property) {
              return _c(
                "div",
                {
                  key: property.id,
                  class: _vm.paddingClasses,
                  style: _vm.paddingInlineStyles
                },
                [
                  property.isShownOnItemPage
                    ? _c("order-property-list-item", {
                        attrs: {
                          group: _vm.propertyGroup.group,
                          property: property
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }